export const AUTH_ERRORS = {
  'auth/email-already-in-use': 'An account with this email already exists',
  'auth/invalid-email': 'Invalid email address',
  'auth/operation-not-allowed': 'Operation not allowed',
  'auth/weak-password': 'Password is too weak',
  'auth/user-disabled': 'This account has been disabled',
  'auth/user-not-found': 'No account found with this email',
  'auth/wrong-password': 'Incorrect password',
  'auth/popup-closed-by-user': 'Sign in was cancelled',
  'auth/cancelled-popup-request': 'Sign in was cancelled',
  'auth/popup-blocked': 'Sign in popup was blocked by your browser',
} as const;

export function getAuthErrorMessage(error: any): string {
  const code = error?.code;
  return AUTH_ERRORS[code as keyof typeof AUTH_ERRORS] || 'Authentication failed';
}